import React from "react";
import ColorInit from "../../../shared/layout/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Header from "../../../shared/layout/Header";
import Footer from "../../../shared/layout/Footer";
import { CartProvider } from "../../cart/context/CartContext";
import BottomFooter from "../../../shared/layout/BottomFooter";
import OrderSuccess from "../components/OrderSuccess";

const OrderSuccessPage = () => {
  

  return (
    <CartProvider>
      <ColorInit color={"bigmall"} />
      <ScrollToTop smooth color="#ef253c" />
      <Header />
      <OrderSuccess />
      <Footer />
      <BottomFooter />
    </CartProvider>
  );
};

export default OrderSuccessPage;
